import { useEffect, useState } from "preact/hooks"

import { useInterval } from "src/utils/hooks"

export const isMember = window.dataLayer[0]["Registrant Type"] !== "Non-Member"


export const useDate = () => {
	const now = new Date()
	const [year, updateYear] = useState(now.getUTCFullYear())
	const [month, updateMonth] = useState(now.getUTCMonth())
	const [date, updateDate] = useState(now.getUTCDate())

	// Really this should set up setTimeouts to update but I'M IN A RUSH
	useInterval(() => {
		const newNow = new Date()
		updateYear(newNow.getUTCFullYear())
		updateMonth(newNow.getUTCMonth())
		updateDate(newNow.getUTCDate())
	}, 1000 * 60 * 5)
	return {year, month, date}
}

export const useTime = () => {
	const now = new Date()
	const [hours, updateHours] = useState(now.getUTCHours())
	const [minutes, updateMinutes] = useState(now.getUTCMinutes())
	const [seconds, updateSeconds] = useState(now.getUTCSeconds())

	// Really this should set up setTimeouts to update but I'M IN A RUSH
	useInterval(() => {
		const newNow = new Date()
		updateHours(newNow.getUTCHours())
		updateMinutes(newNow.getUTCMinutes())
		updateSeconds(newNow.getUTCSeconds())
	}, 5000)
	return {hours, minutes, seconds}
}

export const useDateTime = (resolution = "minute") => {
	const [time, updateTime] = useState(new Date())
	
	useEffect(() => window.setInterval(
		() => updateTime(new Date()),
		resolution === "day" ? 86400000
		: resolution === "hour" ? 3600000
		: resolution === "minute" ? 60000
		: 1000 // 1 second
	), [resolution])

	return time
}

export const useDayOfEvent = () => {
	const {date} = useDate()

	// Event starts on the 25th which is day 1, so we
	// subtract 24 from the date, and then modulo 5
	return date % 5 + 1
}